import { gql } from '@apollo/client';

const INSURANCE_FRAGMENT = gql`
  fragment InsuranceFragment on InsuranceInfo {
    type
    provider
    preAuth
  }
`;

export default INSURANCE_FRAGMENT;
